/**
 * App
 * Using pageName, which is variable in the state, to switch component
 * contact Page content: contactUs, callUs, email
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContactUs from '../components/ContactUs';
import HelpTemplate from '../components/HelpTemplate';
import ContactService from '../components/ContactService';
import QuickAnswer from './QuickAnswer';
import CallUs from './CallUs';
import EmailNoIntent from './EmailNoIntent';
import Notifier from '../containers/Notifier';
import AlertsContainer from '../containers/Alerts';
import { contactPage } from '../constants/UtilVariables';

const App = (props) => {
  // To switch Channel Steering main content
  function getPageContent({ pageName }) {
    switch (pageName) {
      case contactPage.callUs:
        return (<ContactService
          leftPanel={<CallUs />}
          rightPanel={<QuickAnswer pageName={pageName} />}
        />);
      // TODO: Add Email Page content
      case contactPage.email:
        return (<ContactService
          leftPanel={<EmailNoIntent />}
          rightPanel={<QuickAnswer pageName={pageName} />}
        />);
      case contactPage.success :
        return (<div>
          <AlertsContainer />
          <Notifier />
        </div>);
      default:
        return <ContactUs />;
    }
  }

  // The main body content has tree different types: EMAIL/CALLUS/CONTACTUS
  const bodyContent = getPageContent({ pageName: props.pageName });

  return (
    <HelpTemplate>
      { bodyContent }
    </HelpTemplate>
  );
};

function mapStateToProps(state) {
  return {
    pageName: state.location.pageName,
  };
}

// App propTypes
App.propTypes = {
  pageName: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(App);
